import ThemeSuggestions from './ThemeSuggestions';

export default ThemeSuggestions;
